import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import axios from "axios";
import { saveAs } from 'file-saver';
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdDownload, MdFactCheck, MdSchool } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { web_url } from "../../constant";
import TranslatorProfile from "../components/TranslatorProfile";



const url = "http://localhost:8080/api/";
function TranslatorDashboardPageDesktop() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();

    const [open, setOpen] = useState(false);

    const handleClose = () => {

    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };


    const [loadingValues, setLoadingValues] = useState(false);
    const [loadingPage, setLoadingPage] = useState(false);

    const [pEmails, setPEmails] = useState(0);
    const [tEmails, setTEmails] = useState(0);

    const [translatorName, setTranslatorName] = useState('');

    const [studentsAssigned, setStudentsAssigned] = useState([]);

    useEffect(() => {
        if (sessionStorage.getItem('greetings')) {
            const greetings = sessionStorage.getItem("greetings");
            if (greetings === 'true') {
                setLoadingPage(true);
                const getLogDetails = () => {
                    return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                };
                const logDetails = getLogDetails();

                const configToken = {
                    headers: {
                        'Authorization': `Bearer ${logDetails.token}`,
                    },
                };
                const apiUrl = `${web_url}/api/auth/translators/${logDetails.email}`
                axios.get(apiUrl, configToken)
                    .then((response) => {
                        // console.log(response.data);
                        localStorage.setItem('name', response.data.userFullName);
                        localStorage.setItem('mobile', response.data.contactNumber);

                        setTranslatorName(response.data.userFullName)
                        axios.get(`${web_url}/api/auth/researchers`, configToken).then((res) => {

                            const researcherEmail = res.data[0].userEmail;
                            localStorage.setItem('researcherEmail', researcherEmail);

                            axios.get(`${web_url}/api/auth/payments`, configToken).then((resPayment) => {
                                const resultNow = resPayment.data.find(item => item.email === logDetails.email);
                                localStorage.setItem('payment', JSON.stringify(resultNow))

                                const config = {
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': `Bearer ${logDetails.token}`,
                                    },
                                };

                                if (response.data.schoolIds?.length > 0) {
                                    axios.get(`${web_url}/api/auth/schools`, configToken).then((resSchoolList) => {
                                        const assignedSchoolNames = new Set(
                                            resSchoolList.data
                                                .filter(school => response.data.schoolIds.includes(school.id))
                                                .map(school => (school.name || "").trim().toLowerCase())
                                        );

                                        axios.get(`${web_url}/api/auth/students`, configToken).then((resStudents) => {
                                            const allStudents = resStudents.data
                                                .filter(student => student.school && assignedSchoolNames.has(student.school.trim().toLowerCase()))
                                                .map(student => student.userEmail);

                                            setStudentsAssigned(allStudents);
                                            localStorage.setItem('students-assigned', JSON.stringify(allStudents));
                                            setLoadingPage(false);
                                            setOpen(true);
                                        }).catch((err) => {
                                            setStudentsAssigned([]);
                                            localStorage.setItem('students-assigned', JSON.stringify([]));
                                            setLoadingPage(false);
                                        });
                                    }).catch((errSchlList) => {
                                        setStudentsAssigned([]);
                                        localStorage.setItem('students-assigned', JSON.stringify([]));
                                        setLoadingPage(false);
                                    })
                                } else {
                                    setStudentsAssigned([]);
                                    localStorage.setItem('students-assigned', JSON.stringify([]));
                                    setLoadingPage(false);
                                    setOpen(true);
                                }
                            }).catch((errPay) => {
                                setLoadingPage(false);
                            })
                        }).catch((errRes) => {
                            setLoadingPage(false);
                        })
                    })
                    .catch((err) => {
                        console.log("error occured");
                    });
                sessionStorage.removeItem('greetings');
            }

        }
        else {

            const getLogDetails = () => {
                return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
            };
            const logDetails = getLogDetails();

            if (logDetails) {

                const configToken = {
                    headers: {
                        'Authorization': `Bearer ${logDetails.token}`,
                    },
                };

                setLoadingPage(true);
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": `Bearer ${logDetails.token}`,
                    },
                };
                const apiUrl = `${web_url}/api/auth/translators/${logDetails.email}`
                axios.get(apiUrl, configToken)
                    .then((response) => {
                        if (response.data.schoolIds?.length > 0) {
                            axios.get(`${web_url}/api/auth/schools`, configToken).then((resSchoolList) => {
                                const assignedSchoolNames = new Set(
                                    resSchoolList.data
                                        .filter(school => response.data.schoolIds.includes(school.id))
                                        .map(school => (school.name || "").trim().toLowerCase())
                                );

                                axios.get(`${web_url}/api/auth/students`, configToken).then((resStudents) => {
                                    const allStudents = resStudents.data
                                        .filter(student => student.school && assignedSchoolNames.has(student.school.trim().toLowerCase()))
                                        .map(student => student.userEmail);

                                    setStudentsAssigned(allStudents);
                                    localStorage.setItem('students-assigned', JSON.stringify(allStudents));
                                    setLoadingPage(false);
                                }).catch((err) => {
                                    setStudentsAssigned([]);
                                    localStorage.setItem('students-assigned', JSON.stringify([]));
                                    setLoadingPage(false);
                                });
                            }).catch((errSchlList) => {
                                setStudentsAssigned([]);
                                localStorage.setItem('students-assigned', JSON.stringify([]));
                                setLoadingPage(false);
                            })
                        } else {
                            setStudentsAssigned([]);
                            localStorage.setItem('students-assigned', JSON.stringify([]));
                            setLoadingPage(false);
                        }
                    })
                    .catch((err) => {
                        console.log("error occured");
                    });
            }


        }
        localStorage.removeItem('mailreceived')
    }, [])


    useEffect(() => {
        localStorage.setItem('students-assigned', JSON.stringify(studentsAssigned));
    }, [studentsAssigned])

    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (logDetails) {
            const studentList = (studentsAssigned && studentsAssigned.length > 0) ? studentsAssigned : (JSON.parse(localStorage.getItem('students-assigned') || "[]"));
            if (studentList.length > 0) {
                setLoadingValues(true);
                const apiUrl = `${web_url}/api/email-threads/participants/translators-moderate`
                const getLogDetails2 = () => {
                    return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                };
                const logDetails2 = getLogDetails2();

                const configToken = {
                    headers: {
                        'Authorization': `Bearer ${logDetails2.token}`,
                    },
                };
                axios.post(apiUrl, studentList, configToken)
                    .then((response) => {

                        const currentDate = new Date();
                        const startOfWeek = new Date();
                        startOfWeek.setDate(currentDate.getDate() - currentDate.getDay()); // Set to last Monday
                        startOfWeek.setHours(0, 0, 0, 0);

                        const messagesWithNoModeration = response.data.filter(message => studentList.includes(message.sender) && !message.moderationRecord && message.type === "PENPAL" && message.isDraft === "FALSE" && (!message.allocatedTranslator || message.allocatedTranslator === logDetails.email));

                        const messagesWithModeration = response.data.filter(message => message.moderationRecord !== null);

                        const filteredMessagesByModerator = messagesWithModeration.filter(message =>
                            message.moderationRecord.moderator === (logDetails.email)
                        );

                        const messagesModeratedThisWeek = filteredMessagesByModerator.filter(message => {
                            const moderatedDate = new Date(message.moderationRecord.timestamp);
                            const endOfDay = new Date(currentDate);
                            endOfDay.setHours(23, 59, 59, 999);
                            return moderatedDate >= startOfWeek && moderatedDate <= endOfDay;
                        });

                        setPEmails(messagesWithNoModeration.length);
                        setTEmails(messagesModeratedThisWeek.length);
                        setLoadingValues(false);
                    })
                    .catch((err) => {
                        console.log("error occured");
                        console.error("Error fetching email threads:", err);
                        setLoadingValues(false);
                        setPEmails(0);
                        setTEmails(0);
                    });
            }
        }

    }, [studentsAssigned])


    useEffect(() => {
        if (loadingPage) {
            setOpen2(true);
        } else {
            setOpen2(false);
        }
    }, [loadingPage])

    const [open2, setOpen2] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 1270) {
                navigate('/mobile/translator/greeting')
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };

        const checkAuth = () => {
            const logDetails = getLogDetails();
            const currentTime = new Date();

            if (!logDetails) {
                alert("Please re-sign up to continue");
                localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            } else if (logDetails.category.toLowerCase() !== "translator") {
                alert("Please re-sign up to continue");
                // localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            }

            if (sessionStorage.getItem('exp')) {
                if (new Date(sessionStorage.getItem('exp')) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                } else if (sessionStorage.getItem('exp') !== logDetails.exp) {
                    alert("Please re-sign up to continue");
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            } else {
                sessionStorage.setItem('exp', logDetails.exp);
                if (new Date(logDetails.exp) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            }
        };

        checkAuth(); // Run on mount

        const handleStorageChange = (event) => {
            if (event.key === "logDetails") {
                checkAuth(); // Re-check authentication if storage changes
            }
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else if (err.toLowerCase().includes('no pending messages')) {
            setError('No pending mails to download.');
        } else if (err.toLowerCase().includes('no messages to download')) {
            setError(t('t440'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        localStorage.setItem("refresh", `${Date.now()}`);
        setOpenError(false);
    };


    const downloadMailsTranslated = () => {
        const logDetails = JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));

        if (logDetails && localStorage.getItem('students-assigned')) {
            const studentList = JSON.parse(localStorage.getItem("students-assigned") || "[]");
            if (studentList.length > 0) {
                setLoadingPage(true);

                const getLogDetails = () => {
                    return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                };
                const logDetails = getLogDetails();

                const configToken = {
                    headers: {
                        'Authorization': `Bearer ${logDetails.token}`,
                    },
                };

                axios.post(`${web_url}/api/email-threads/by-participants`, studentList, configToken).then((response) => {
                    const allMessages = response.data.flatMap(thread =>
                        thread.messages.map(message => ({
                            threadId: thread.threadId,
                            messageId: message.messageId,
                            subject: thread.subject || "(no subject)",
                            translatedSubject: thread.translatedSubject || "(no subject)",
                            sentAt: formatDate(message.sentAt),
                            sentAtOriginal: formatDateNew(message.sentAt),
                            body: message.body || "(No message body)",
                            translatedBody: message.translatedBody || "(No translated body)",
                            sender: message.sender,
                            other: thread.participants.find(email => email !== message.sender) || null,
                            isDraft: message.isDraft,
                            status: message.status,
                            type: message.type,
                            moderationRecord: message.moderationRecord,
                            moderatedTime_local: message.moderationRecord ? formatDate(message.moderationRecord.timestamp) : null,
                            moderator: message.moderationRecord ? message.moderationRecord.moderator : null,
                            allocatedTranslator: logDetails.email
                        }))
                    );

                    const moderatedMessages = allMessages.filter(msg =>
                        studentList.includes(msg.sender) &&
                        msg.moderationRecord !== null &&
                        msg.type === "PENPAL" &&
                        msg.moderator === logDetails.email
                    );

                    if (moderatedMessages.length === 0) {
                        setLoadingPage(false);
                        handleClickOpenError("No messages to download");
                        return;
                    }

                    const textContent = moderatedMessages.map(msg => {
                        return (
                            `From: ${msg.sender}\n` +
                            `To: ${msg.other}\n` +
                            `Subject: ${msg.subject}\n` +
                            `Message Body:\n${msg.body.replace(/<[^>]*>/g, '')}\n\n` +
                            `Translated Subject: ${msg.translatedSubject}\n` +
                            `Translated Body:\n${msg.translatedBody.replace(/<[^>]*>/g, '')}\n\n` +
                            `-------------------------------------------\n`
                        );
                    }).join("\n");

                    const blob = new Blob([textContent], { type: "text/plain;charset=utf-8" });
                    saveAs(blob, "translated_messages.txt");

                    setLoadingPage(false);

                }).catch((err) => {
                    console.error("Error downloading messages", err);
                    setLoadingPage(false);
                });
            }
        }

    };

    const downloadMailsPending = () => {
        const logDetails = JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));

        if (logDetails && localStorage.getItem('students-assigned')) {
            const studentList = JSON.parse(localStorage.getItem("students-assigned") || "[]");
            if (studentList.length > 0) {
                setLoadingPage(true);

                const getLogDetails = () => {
                    return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                };
                const logDetails = getLogDetails();

                const configToken = {
                    headers: {
                        'Authorization': `Bearer ${logDetails.token}`,
                    },
                };

                axios.post(`${web_url}/api/email-threads/by-participants`, studentList, configToken).then((response) => {
                    const allMessages = response.data.flatMap(thread =>
                        thread.messages.map(message => ({
                            threadId: thread.threadId,
                            messageId: message.messageId,
                            subject: thread.subject || "(no subject)",
                            sentAt: formatDate(message.sentAt),
                            sentAtOriginal: formatDateNew(message.sentAt),
                            body: message.body || "(No message body)",
                            sender: message.sender,
                            other: thread.participants.find(email => email !== message.sender) || null,
                            isDraft: message.isDraft,
                            status: message.status,
                            type: message.type,
                            moderationRecord: message.moderationRecord,
                            allocatedTranslator: message.allocatedTranslator
                        }))
                    );

                    const pendingMessages = allMessages.filter(msg =>
                        studentList.includes(msg.sender) &&
                        !msg.moderationRecord &&
                        msg.type === "PENPAL" &&
                        msg.isDraft === "FALSE" &&
                        (!msg.allocatedTranslator || msg.allocatedTranslator === logDetails.email)
                    );

                    if (pendingMessages.length === 0) {
                        setLoadingPage(false);
                        handleClickOpenError("No pending messages");
                        return;
                    }

                    const textContent = pendingMessages.map(msg => {
                        return (
                            `From: ${msg.sender}\n` +
                            `To: ${msg.other}\n` +
                            `Subject: ${msg.subject}\n` +
                            `Message Body:\n${msg.body.replace(/<[^>]*>/g, '')}\n\n` +
                            `-------------------------------------------\n`
                        );
                    }).join("\n");

                    const blob = new Blob([textContent], { type: "text/plain;charset=utf-8" });
                    saveAs(blob, "pending_messages.txt");

                    setLoadingPage(false);

                }).catch((err) => {
                    console.error("Error downloading messages", err);
                    setLoadingPage(false);
                });
            }
        }

    };


    const formatDate = (timestamp) => {
        const dateObj = new Date(timestamp);

        // Convert to IST (UTC + 5:30)
        // const istOffset = 0;
        const istOffset = 5.5 * 60 * 60 * 1000; // 5.5 hours in milliseconds
        const istTime = new Date(dateObj.getTime() + istOffset);

        // Use .getFullYear(), .getMonth(), etc., instead of .getUTC*
        const year = istTime.getFullYear();
        const month = String(istTime.getMonth() + 1).padStart(2, "0"); // Ensure 2 digits
        const day = String(istTime.getDate()).padStart(2, "0"); // Ensure 2 digits
        const hours = String(istTime.getHours()).padStart(2, "0"); // Corrected
        const minutes = String(istTime.getMinutes()).padStart(2, "0"); // Corrected
        const sec = String(istTime.getSeconds()).padStart(2, "0"); // Corrected

        // console.log("old", timestamp);
        // console.log("new", `${year}-${month}-${day} ${hours}:${minutes}:${sec}`);

        return `${year}-${month}-${day} ${hours}:${minutes}:${sec}`;
    }

    const formatDateNew = (timestamp) => {
        return new Date(timestamp).toISOString(); // Ensures cross-browser compatibility
    };

    return (
        <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} bg-bgImg md:bg-bglarge bg-repeat bg-cover min-h-screen w-screen xl:pt-[50px]`}>
            <div className="xl:hidden absolute top-0 left-0 py-[25px] pl-[20px] md:pl-[30px] lg:pl-[40px]">
                <div className="flex justify-center items-center" >
                    <img className="h-[50px] md:h-[70px] lg:h-[90px]" src="/images/logo.svg" alt="logo" />
                    <p className="ml-[10px]  font-semibold text-[16px] md:text-[20px] lg:text-[25px]">{t('t1')}</p>
                </div>
            </div>
            <Menu as="div" className="xl:hidden absolute top-0 right-0 text-left items-right py-[30px] md:py-[35px] pr-[20px] md:pr-[30px] lg:pr-[40px]">
                <div>
                    <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 lg:py-3 text-sm md:text-[17px] md:text-[21px] font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                        {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                        <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 md:size-6 text-gray-400" />
                    </MenuButton>
                </div>

                <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-2 w-[200px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                    <div className="py-1">
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("English");
                                    changeLanguage('en')
                                }}
                            >
                                English
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Sinhala");
                                    changeLanguage('si')
                                }}
                            >
                                සිංහල
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Tamil");
                                    changeLanguage('ta')
                                }}
                            >
                                தமிழ்
                            </button>
                        </MenuItem>
                    </div>
                </MenuItems>
            </Menu>
            <div className="rounded-md hidden xl:grid grid-cols-3 py-[5px] 2xl:py-[10px] bg-gradient-to-r from-[#FFA803] to-[#FFD12E] mx-[70px] px-[20px]">
                <div className="flex justify-start items-center">
                    <img className="h-[40px]" src="/images/logo.svg" alt="logo" />
                    <p className="ml-[10px] font-semibold text-[20px]">{t('t1')}</p>
                </div>
                <div className="grid grid-cols-3 w-full">
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/home-w.svg" alt="home" onClick={() => navigate('/desktop/translator/dashboard')} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t410')}
                        </span>
                    </div>
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/mail-b.svg" alt="mail" onClick={() => {
                            const mailRequest = {
                                type: 'new',
                                subject: 'nothing'
                            };
                            localStorage.setItem('threadId', JSON.stringify(mailRequest));
                            navigate('/desktop/translator/mailbox')

                        }} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t411')}
                        </span>
                    </div>
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img title="Settings" src="/images/top-icons/settings-b.svg" alt="settings" onClick={() => navigate('/desktop/translator/settings')} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t153')}
                        </span>
                    </div>
                </div>
                <div className="flex justify-end items-center">
                    <Menu as="div" className="text-left items-right">
                        <div>
                            <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 lg:py-3 text-sm md:text-[17px] md:text-[21px] font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                                {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                                <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 md:size-6 text-gray-400" />
                            </MenuButton>
                        </div>

                        <MenuItems
                            transition
                            className="absolute right-0 z-10 mt-2 w-[200px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                        >
                            <div className="py-1">
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("English");
                                            changeLanguage('en')
                                        }}
                                    >
                                        English
                                    </button>
                                </MenuItem>
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("Sinhala");
                                            changeLanguage('si')
                                        }}
                                    >
                                        සිංහල
                                    </button>
                                </MenuItem>
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("Tamil");
                                            changeLanguage('ta')
                                        }}
                                    >
                                        தமிழ்
                                    </button>
                                </MenuItem>
                            </div>
                        </MenuItems>
                    </Menu>
                </div>
            </div>
            <div className="grid grid-cols-2 w-full">
                <div className="">
                    <div className="pt-[100px] md:pt-[130px] lg:pt-[150px] xl:pt-[30px] w-full">
                        <div className="bg-[#FDC50C] rounded-2xl ml-[30px] md:ml-[60px] lg:ml-[80px] xl:ml-[80px] w-[160px] md:w-[180px] flex justify-center">
                            <p className={`${i18n.language === "en" ? "xl:text-[20px] 2xl:text-[22px]" : "xl:text-[17px] 2xl:text-[19px]"} font-bold px-[10px] py-[5px] md:px-[13px] md:py-[8px]`}>{t('t104')}</p>
                        </div>
                    </div>
                    <div className="grid grid-cols-2 mt-[30px] xl:ml-[80px] xl:mr-[20px]">
                        <div className="flex flex-col justify-center items-center mr-[10px] lg:mr-[20px] xl:mr-[30px]">
                            <div className="bg-[#DDC69D] w-full flex justify-center rounded-t-xl">
                                <p className="text-center text-[#695531] text-[15px] md:text-[16px] lg:text-[18px] font-bold px-[20px] py-[10px] md:px-[25px] md:py-[15px] lg:px-[25px] lg:py-[15px]">{t('t176')}</p>
                            </div>

                            <div className="bg-[#FEF2DC] w-full flex justify-center rounded-b-xl">
                                {
                                    loadingValues ?
                                        <div className="items-center justify-center flex p-3">
                                            <div className='w-7 h-7 border-2 border-t-transparent border-[#695531] rounded-full animate-spin'></div>
                                        </div>
                                        :
                                        <p className="text-[#A07B00] font-bold text-[40px] px-[20px] py-[10px]">{pEmails}</p>
                                }

                            </div>
                        </div>
                        <div className="flex flex-col justify-center items-center ml-[10px] lg:ml-[20px] xl:ml-[30px]">
                            <div className="bg-[#A1E0BB] w-full flex justify-center rounded-t-xl">
                                <p className="text-[#336C4B] text-[15px] md:text-[16px] lg:text-[18px] font-bold px-[20px] py-[10px] md:px-[25px] md:py-[15px] lg:px-[25px] lg:py-[15px]">{t('t177')}</p>
                            </div>
                            <div className="bg-[#DBFAE8] w-full flex justify-center rounded-b-xl">
                                {
                                    loadingValues ?
                                        <div className="items-center justify-center flex p-3">
                                            <div className='w-7 h-7 border-2 border-t-transparent border-[#336C4B] rounded-full animate-spin'></div>
                                        </div>
                                        :
                                        <p className="text-[#336C4B] font-bold text-[40px] px-[20px] py-[10px]">{tEmails}</p>
                                }

                            </div>
                        </div>
                    </div>

                    <div className="hidden xl:grid grid-cols-3 mt-[30px] 2xl:mt-[50px] ml-[80px] xl:mr-[20px] gap-4">
                        <div className="flex justify-center items-center cursor-pointer h-[70px]" onClick={() => navigate('/desktop/translator/translatemail')}>
                            <div className="p-[17px] bg-[#A07B00] rounded-l-lg h-full flex items-center w-[70px]">
                                <MdFactCheck size={30} color="#FDC50C" />
                            </div>
                            <div className="bg-[#FFEBA9] py-[20px] pl-[10px] w-full rounded-r-lg h-full flex items-center pr-[10px]">
                                <p className="text-black text-[14px] 2xl:text-[16px] font-bold">{t('t178')}</p>
                            </div>
                        </div>
                        <div className="flex justify-center items-center cursor-pointer h-[70px]" onClick={downloadMailsPending}>
                            <div className="p-[17px] bg-[#A07B00] rounded-l-lg h-full flex items-center w-[70px]">
                                <MdDownload size={30} color="#FDC50C" />
                            </div>
                            <div className="bg-[#FFEBA9] py-[20px] pl-[10px] w-full rounded-r-lg h-full flex items-center pr-[10px]">
                                <p className="text-black text-[14px] 2xl:text-[16px] font-bold">Download Pending</p>
                            </div>
                        </div>
                        <div className="flex justify-center items-center cursor-pointer h-[70px]" onClick={downloadMailsTranslated}>
                            <div className="p-[17px] bg-[#A07B00] rounded-l-lg h-full flex items-center w-[70px]">
                                <MdDownload size={30} color="#FDC50C" />
                            </div>
                            <div className="bg-[#FFEBA9] py-[20px] pl-[10px] w-full rounded-r-lg h-full flex items-center pr-[10px]">
                                <p className="text-black text-[14px] 2xl:text-[16px] font-bold">{t('t439')}</p>
                            </div>
                        </div>
                        <div className="flex justify-center items-center cursor-pointer h-[70px]" onClick={() => navigate('/translator/school-letter-downloads')}>
                            <div className="p-[17px] bg-[#A07B00] rounded-l-lg h-full flex items-center w-[70px]">
                                <MdSchool size={30} color="#FDC50C" />
                            </div>
                            <div className="bg-[#FFEBA9] py-[20px] pl-[10px] w-full rounded-r-lg h-full flex items-center pr-[10px]">
                                <p className="text-black text-[14px] 2xl:text-[16px] font-bold">School Letters</p>
                            </div>
                        </div>

                    </div>

                </div>
                <div>
                    <TranslatorProfile t={t} />
                </div>
            </div>
            <div className="xl:hidden grid grid-cols-3 fixed bottom-0 w-full border-t border-gray-300 bg-white">
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/home.svg" alt="home" /></div>
                {/* <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/mail.svg" /></div> */}
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/person.svg" /></div>
                {/* <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/message.svg" /></div> */}
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/settings.svg" /></div>
            </div>

            <Dialog
                open={open}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogContent className="bg-[#FFF6DA]">

                    <DialogContent
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        <div className="flex flex-col justify-center items-center">
                            <p className="font-bold text-[15px] 2xl:text-[18px]">{t('t79')} {translatorName}</p>
                            <p className="pt-[20px] text-[15px] 2xl:text-[18px]">{t('t175')}</p>
                        </div>
                    </DialogContent>

                </DialogContent>
                <DialogActions
                    style={{
                        backgroundColor: '#FFF6DA',
                        display: 'flex',
                        justifyContent: 'center',
                        width: '100%',
                    }}
                >
                    <Button
                        disabled={loadingPage}
                        onClick={() => {
                            setOpen(false);
                        }}
                        style={{
                            margin: '0px 0px 10px 0px',
                            backgroundColor: '#F2AC0E',
                            color: 'white',
                            padding: '10px 20px', // px-4 py-2
                            borderRadius: '0.375rem', // rounded-md
                            fontWeight: 'bold',
                        }}
                    >
                        {t('t7')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open2}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogContent className="bg-[#FFF6DA]">

                    <DialogContent
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        <div className="items-center justify-center flex">
                            <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                        </div>
                    </DialogContent>

                </DialogContent>
            </Dialog>

            <Dialog
                open={openError}
                onClose={handleCloseError}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {error}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default TranslatorDashboardPageDesktop;

